<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>角色管理</h6>
      <el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加角色</el-button>
      <!--<el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button>
			<el-input class="querys" v-model.trim="dw" placeholder="单位"></el-input>
			<el-input class="querys" v-model.trim="username" placeholder="用户姓名"></el-input>-->
    </div>
    <div class="tabBody">
      <el-table :data="tabledata" :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
        <el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
        <el-table-column prop="roleName" align="center" label="角色名称"></el-table-column>
        <el-table-column prop="roleCode" align="center" label="角色编码"></el-table-column>
        <el-table-column prop="remark" align="center" label="备注信息"></el-table-column>
        <!--<el-table-column prop="createDate" align="center" label="创建日期"></el-table-column>-->
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="success" class="tableedit" icon="el-icon-edit" circle
              @click="edit(scope.row,scope.$index)"></el-button>
            <el-button type="warning" class="tableedit" icon="el-icon-delete" circle
              @click="deletes(scope.row,scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fye">
      <pagintion @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums"></pagintion>
    </div>
    <rolepopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel"
      @adddata="Adddata"></rolepopup>
  </div>
</template>

<script>
  import pagintion from '@/components/mangement/pagintion.vue';
  import rolepopup from "./popup/rolepopup.vue";

  import {
    rolelist,
    roledelete
  } from "@/api/api";

  export default {
    data() {
      return {
        tabledata: [],
        tableHeight: window.innerHeight - 180,
        total: 0,
        pageSize: 20, //每页多少条数据分页
        pageNum: 0, //当前页
        pageNums: null,
        username: '',
        dw: '',
        dialogVisible: false,
        Addsid: [],
      }
    },
    components: {
      pagintion,
      rolepopup
    },
    mounted() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,

      }

      this.list(params)
    },
    methods: {
      list(params) {

        rolelist(params).then((res) => {
          console.log(res);

          this.total = res.total;
          this.tabledata = res.data;

        })

      },
      DsyData(data) { //多少页
        this.pageNum = data.dsy;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,

        }
        this.list(params)
      },
      DstData(data) { //多少条
        this.pageSize = data.dst;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,

        }
        this.list(params)
      },
      Getcancel(data) {
        this.dialogVisible = data.dialogVisible;
      },
      edit(row, index) {
        this.dialogVisible = true;
        this.Addsid = ["bj", row];
      },
      Adddata(data) {
        this.dialogVisible = false;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,

        }
        this.list(params)

      },
      addClick() {
        this.dialogVisible = true;
        this.Addsid = ["xz"];
      },
      Bjadddata(data) {
        this.dialogVisible = data.dialogVisible;
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,

        }
        this.list(params)
      },
      deletes(row, index) {
        console.log(row)
        this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            let params = {};
            roledelete({
              id: row.id
            }).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: "提示",
                  message: res.message,
                  type: "success",
                });
                let params = {
                  pageSize: this.pageSize,
                  pageNum: this.pageNum,
                }
                this.list(params)

              } else {
                this.$notify({
                  title: "提示",
                  message: res.message,
                  type: "success",
                });
              }

            })
          }
        }).catch(() => {

          this.$message({
            message: '已取消',
            type: 'warning'
          });
        });
      },
    }
  }
</script>

<style scoped>
  @import url('../../common/css/mangementall.css');

  .querys {
    height: 30px;
    float: right;
    width: 200px;
    margin-top: 10px;
    margin-right: 10px;
  }

  >>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #606266;
    font-size: 14px;
  }
</style>
